import React, { useEffect, useRef, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { useGetSalesListQuery } from "../../../../features/api/saleslistApi";
import { useGetDealersQuery } from "../../../../features/api/dealerApi";
import axios from "axios";
import { useGetInvoicesQuery } from "../../../../features/api/orderinvoiceApi";
import numberToWords from "number-to-words";
import headerLogo from "../../../../asset/johura_logo.png";
import signature from "../../../../asset/signature.png";

import {
  Document,
  Page,
  Text,
  View,
  Image,
  StyleSheet,
} from "@react-pdf/renderer";
import { PDFViewer } from "@react-pdf/renderer";
import { formatDate } from "../../../../components/CommonDateFormat";
import { API_BASE_URL } from "../../../../components/baseUrl";

const styles = StyleSheet.create({
  page: {
    backgroundColor: "white",
    paddingBottom: "88pt",
  },
  header: {
    color: "white",
    marginBottom: 5,
    textAlign: "center",
    height: "3.8cm",
  },
  imgborder: {
    borderBottom: "1px solid green",
    paddingBottom: "5px",
    marginBottom: "3px",
  },
  HedingTextBorder: {
    borderBottom: "1px solid red",
  },

  invTitle: {
    textAlign: "center",
    backgroundColor: "black",
    color: "white",
    padding: "4px 0px",
    fontSize: "12px",
    width: "40px",
    borderRadius: "2px",
    margin: "0 auto",
  },
  invoice: {
    padding: "10px 20px",
    fontSize: "10px",
    flexDirection: "row",
    justifyContent: "space-between",
  },
  invLeft: {
    fontWeight: "bold",
    flexDirection: "column",
    gap: "4px",
    fontSize: "12px",
  },
  invRight: {
    fontSize: "12px",
  },
  invBottom: {
    fontSize: "11px",
    padding: "0 20 10 20",
    flexDirection: "column",
    gap: "8px",
  },
  footer: {
    color: "white",
    height: "2cm",
    position: "absolute",
    bottom: 0,
    left: 0,
    right: 0,
    marginTop: 20,
    textAlign: "center",
    flexDirection: "row",
    justifyContent: "center",
    fontSize: "12",
  },
  footerAddr: {
    height: "",
    color: "black",
    fontSize: "8px",
    margin: "13 auto",
    width: "100%",
    fontWeight: "thin",
  },
  footerBgc: {
    backgroundColor: "#006600",
    height: "0.8cm",
    position: "absolute",
    bottom: 0,
    left: 0,
    right: 0,
  },
  table: {
    borderWidth: 1,
    marginHorizontal: 20,
    borderColor: "#D0D0D0",
    fontSize: "11",
    flexFlow: 1,
  },
  tableHeaderBg: {
    backgroundColor: "#aaa",
  },
  tableRow: {
    flexDirection: "row",
  },
  tableCell: {
    borderBottomWidth: 1,
    borderRight: 1,
    borderColor: "#D0D0D0",
    textAlign: "center",
    padding: 6,
  },
  tableCellTitle: {
    marginBottom: 4,
    fontSize: 12,
    fontWeight: "bold",
    textAlign: "center",
  },
  author: {
    fontSize: "10px",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    marginTop: "20px",
    padding: "0 20px",
  },
  authorText: {
    borderTop: "1px solid black",
    paddingTop: "1px",
  },
  thanks: {
    fontSize: "11px",
    display: "flex",
    flexDirection: "column",
    marginTop: "30px",
    padding: "0 20px",
    gap: "5px",
  },
  thanksText: { marginBottom: "80px" },
  pageNumber: {
    position: "absolute",
    bottom: 55,
    right: 20,
    fontSize: 10,
  },
});

function ReportWithoutDue() {
  const [visible, setVisible] = useState(false);
  const [isSignature, setIsSignature] = useState(false);

  const location = useLocation();
  const row = location?.state?.row;
  const dName = location?.state?.dName;
  const orderInvoice = row;
  const invoice_no = orderInvoice?.inv_no;

  const orders = useGetSalesListQuery(null, {
    refetchOnMountOrArgChange: true,
  })?.data?.orderss;

  const orders2 = useGetInvoicesQuery(null, {
    refetchOnMountOrArgChange: true,
  })?.data?.orders_twos;

  const filteredItems = orders2?.filter(
    (item) =>
      item?.dealer === orderInvoice?.dealer &&
      parseInt(item?.inv_no) < invoice_no
  );
  const sumOfTotal = filteredItems?.reduce((sum, item) => sum + item?.total, 0);
  const sumOfPaid = filteredItems?.reduce((sum, item) => sum + item?.paid, 0);
  const totalPrevDue = sumOfTotal - sumOfPaid;

  const dealers = useGetDealersQuery(null, {
    refetchOnMountOrArgChange: true,
  })?.data?.dealer;

  // filter for select invoice
  const filterOrders = orders?.filter((order) => order?.inv_no === invoice_no);

  console.log(filterOrders);

  const filterDealer = dealers?.filter(
    (d) => d?.d_name === orderInvoice?.dealer
  );
  const findDealer = filterDealer?.find((d) => d);

  const [transaction, setTransaction] = useState([]);
  useEffect(() => {
    const fetchTransaction = async () => {
      const response = await axios.get(
        `${API_BASE_URL}/api/TransactionQuery?ledger_id=1&tag_ac_id=${findDealer?.id}`
      );
      setTransaction(response?.data?.transactions);
    };
    fetchTransaction();
  }, [findDealer?.id]);

  let balance = 0;

  transaction?.map((data, index) => {
    const { dabit_amount, credit_amount } = data;
    balance += dabit_amount - credit_amount;
    return balance;
  });

  const user = JSON.parse(localStorage.getItem("user"));

  return (
    <div className="w-full max-w-[1280px] mx-auto px-6 md:px-auto overflow-auto">
      <div className="flex gap-6 items-center justify-between my-2">
        <div className="flex items-center gap-x-2">
          <div className="flex items-center gap-x-2">
            <input
              onClick={() => setVisible(!visible)}
              type="checkbox"
              className="cursor-pointer"
            />
            <span>Pad logo</span>
          </div>
          <div className="flex items-center gap-x-2">
            <input
              onClick={() => setIsSignature(!isSignature)}
              type="checkbox"
              className="cursor-pointer"
            />
            <span>Signature</span>
          </div>
        </div>
        <Link
          to="/dashboard/orders"
          className="border bg-blue-500 px-2 rounded text-white"
        >
          Back
        </Link>
      </div>
      <PDFViewer style={{ width: "100%", height: "100vh" }}>
        <Document>
          <Page size="A4" style={styles.page}>
            {/* Header */}
            <View style={styles.header} fixed>
              {visible && (
                <View>
                  <View style={styles.imgborder}>
                    <Image src={headerLogo} />
                  </View>
                  <Text style={styles.HedingTextBorder}></Text>
                </View>
              )}
            </View>

            {/* Invoice */}
            <View style={styles.invMain}>
              <Text style={styles.invTitle}>Bill</Text>
              <View style={styles.invoice}>
                <View style={styles.invLeft}>
                  <Text>To</Text>
                  <Text>{dName?.d_addressing}</Text>
                  <Text>{dName?.d_name}</Text>
                  <Text>{dName?.d_address}</Text>
                </View>
                <View style={styles.invRight}>
                  <Text>Bill No: {invoice_no}</Text>
                  <Text>Bill Date: {formatDate(orderInvoice?.inv_date)}</Text>
                </View>
              </View>
              <View style={styles.invBottom}>
                <Text>
                  <Text style={{ fontSize: "12px" }}>Sub:</Text>{" "}
                  {row?.subjectName}
                </Text>
                <Text>{row?.bill_ref}</Text>
                <Text>Delivery Date: {formatDate(orderInvoice?.d_date)}</Text>
              </View>
            </View>

            {/* Table */}
            <View style={styles.table}>
              {/* Table Header */}
              <View
                style={{ ...styles.tableRow, ...styles.tableHeaderBg }}
                fixed
              >
                <View style={{ ...styles.tableCell, width: "8%" }}>
                  <Text>Sl No.</Text>
                </View>
                <View style={{ ...styles.tableCell, width: "24%" }}>
                  <Text>Product Name</Text>
                </View>
                <View style={{ ...styles.tableCell, width: "28%" }}>
                  <Text>Description</Text>
                </View>
                <View style={{ ...styles.tableCell, width: "10%" }}>
                  <Text>Quantity</Text>
                </View>
                <View style={{ ...styles.tableCell, width: "15%" }}>
                  <Text>Sales Rate</Text>
                </View>
                <View
                  style={{ ...styles.tableCell, width: "15%", borderRight: 0 }}
                >
                  <Text>Total Amount</Text>
                </View>
              </View>

              {/* Table Data */}
              {filterOrders?.map((data, index) => {
                return (
                  <View key={index} style={styles.tableRow}>
                    <View style={{ ...styles.tableCell, width: "8%" }}>
                      <Text>{index + 1}</Text>
                    </View>
                    <View
                      style={{
                        ...styles.tableCell,
                        width: "24%",
                        textAlign: "left",
                      }}
                    >
                      <Text>
                        {data?.product} - {data?.model}
                      </Text>
                    </View>
                    <View
                      style={{
                        ...styles.tableCell,
                        width: "28%",
                        textAlign: "left",
                      }}
                    >
                      <Text>{data?.rmks}</Text>
                    </View>
                    <View
                      style={{
                        ...styles.tableCell,
                        width: "10%",
                        textAlign: "center",
                      }}
                    >
                      <Text>{data?.qty}</Text>
                    </View>
                    <View style={{ ...styles.tableCell, width: "15%" }}>
                      <Text> {data?.sales_rate}</Text>
                    </View>
                    <View
                      style={{
                        ...styles.tableCell,
                        width: "15%",
                        borderRight: 0,
                      }}
                    >
                      <Text>{data?.total}</Text>
                    </View>
                  </View>
                );
              })}
              <View style={styles.tableRow}>
                <View
                  style={{
                    ...styles.tableCell,
                    borderRight: 0,
                    width: "100% ",
                    borderBottom: 0.3,
                    flexDirection: "row",
                    justifyContent: "space-between",
                  }}
                >
                  <Text style={{ textTransform: "capitalize" }}>
                    ( In word:{" "}
                    {typeof orderInvoice?.total !== "number" ||
                    !isFinite(orderInvoice?.total)
                      ? "error"
                      : numberToWords.toWords(orderInvoice?.total)}{" "}
                    Taka Only)
                  </Text>
                  <Text style={{ fontSize: "11px" }}>
                    Sub Total: {orderInvoice?.total}
                  </Text>
                </View>
              </View>
              {orderInvoice?.discount > 0 && (
                <View style={styles.tableRow}>
                  <View
                    style={{
                      ...styles.tableCell,
                      borderRight: 0,
                      width: "100% ",
                      borderBottom: 0.3,
                      textAlign: "right",
                    }}
                  >
                    <Text style={{ fontSize: "11px" }}>
                      Discount: {orderInvoice?.discount}
                    </Text>
                  </View>
                </View>
              )}
              {orderInvoice?.discount > 0 && (
                <View style={styles.tableRow}>
                  <View
                    style={{
                      ...styles.tableCell,
                      borderRight: 0,
                      width: "100% ",
                      borderBottom: 0.3,
                      textAlign: "right",
                    }}
                  >
                    <Text style={{ fontSize: "11px" }}>
                      Total: {orderInvoice?.grand_total}
                    </Text>
                  </View>
                </View>
              )}
              <View style={styles.tableRow}>
                <View
                  style={{
                    ...styles.tableCell,
                    borderRight: 0,
                    width: "100% ",
                    borderBottom: 0.3,
                    textAlign: "right",
                  }}
                >
                  <Text style={{ fontSize: "11px" }}>
                    Paid Amount: {orderInvoice?.paid}
                  </Text>
                </View>
              </View>
              <View style={styles.tableRow}>
                <View
                  style={{
                    ...styles.tableCell,
                    borderRight: 0,
                    width: "100% ",
                    borderBottom: 0,
                    textAlign: "right",
                  }}
                >
                  <Text style={{ fontSize: "11px" }}>
                    Due Amount: {orderInvoice?.grand_total - orderInvoice?.paid}
                  </Text>
                </View>
              </View>
            </View>

            <View style={styles.thanks}>
              <Text style={styles.thanksText}>Thanks for</Text>
              {isSignature && (
                <View>
                  <View
                    style={{
                      width: "100px",
                      marginTop: "-80px",
                      marginLeft: "-12px",
                    }}
                  >
                    <Image src={signature} />
                  </View>
                </View>
              )}
              <Text>Engr. Md Jahangir Alam</Text>
              <Text>Managing Director</Text>
              {/* <Text>JOHURA ENDOMED SOLUTION</Text> */}
            </View>
            <View style={styles.author}>
              <Text>Prepared By: Johura Endomed Solution</Text>
            </View>

            {/* Page Number */}
            <View style={styles.pageNumber} fixed>
              <Text
                render={({ pageNumber, totalPages }) =>
                  `page ${pageNumber} of ${totalPages}`
                }
              />
            </View>

            {/* Footer */}
            <View style={styles.footer} fixed>
              {visible && (
                <View style={styles.footerAddr}>
                  <Text>
                    15/A Zigatola, Hafizullah Green Tower, Flat # C1, Dhanmondi,
                    Dhaka - 1209
                  </Text>
                  <Text>
                    Cell: 01711-071102, 01977-071102, 01778-874364, E-mail:
                    jahangirjohura@gmail.com / Web: www.johurabd.com
                  </Text>
                </View>
              )}
              {visible && <Text style={styles.footerBgc}></Text>}
            </View>
          </Page>
        </Document>
      </PDFViewer>
    </div>
  );
}

export default ReportWithoutDue;
